// Depends
import { group } from '@/helpers/routes'
import { routes as dashboard } from './dashboard'
import { routes as profile } from './profile'
import { routes as unit } from './unit'
import { routes as car } from './car'
import { routes as parking } from './parking'
import { routes as moving } from './moving'
import { routes as bike } from './bike'
import { routes as rent } from './rent-parking'
import { routes as rental } from './rental'
import { routes as occurrence } from './book-occurrence'
import { routes as files } from './files'
import { routes as meetings } from './meeting'
import { routes as accountability } from './accountability'
import { routes as guest } from './guest'
import { routes as commonarea } from './common-area'
import { routes as access } from './access'
import { routes as living } from './livings'
import { routes as pets } from './pets'

export default [
  ...group('/app/tenant', [
    ...dashboard,
    ...profile,
    ...unit,
    ...car,
    ...parking,
    ...moving,
    ...bike,
    ...rent,
    ...rental,
    ...occurrence,
    ...files,
    ...meetings,
    ...accountability,
    ...guest,
    ...commonarea,
    ...access,
    ...living,
    ...pets
  ])
]



// WEBPACK FOOTER //
// ./src/app/tenant/routes.js